import { render, staticRenderFns } from "./CorporateAreaForm.vue?vue&type=template&id=0b23d398"
import script from "./CorporateAreaForm.vue?vue&type=script&lang=js"
export * from "./CorporateAreaForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports